import { useState } from 'react';
import type { ChangeEvent } from 'react';

import { FaIcon } from '@/ui';

export type UploadFileButtonProps = {
  onFileChanged: (file: File) => void | Promise<void>;
  disabled: boolean;
  isUploading: boolean;
};

export function UploadFileButton({ onFileChanged, disabled, isUploading }: UploadFileButtonProps) {
  const [inputId] = useState(() => `input-${crypto.randomUUID().replaceAll('-', '')}`);

  const fileChanged = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file !== undefined) {
      void onFileChanged(file);
    }
  };

  return (
    <div className="d-inline">
      <input
        type="file"
        accept="image/jpeg"
        onChange={fileChanged}
        id={inputId}
        disabled={disabled}
        className="d-none"
      />

      <label htmlFor={inputId} className={`btn btn-light btn-sm ${disabled ? 'disabled' : ''}`}>
        {isUploading ? (
          <i className="spinner-border spinner-border-sm text-dark" role="status" />
        ) : (
          <FaIcon icon="fal fa-paperclip" />
        )}
      </label>
    </div>
  );
}
